<template>
  <div class="links">
    <LTSHeader></LTSHeader>
    <div class="container">
      <div
        v-if="user_details.isSystemAdministrator || user_details.isAdministrator || user_details.isSAICAModerator"
        class="user-details"
      >
        <div class="admin-description">
          {{ user_details.isSAICAModerator ? "Moderator" : "Administrator" }}
        </div>
        <div class="admin-buttons">
          <router-link
            v-if="user_details.isSystemAdministrator || user_details.isAdministrator || user_details.isSAICAModerator"
            to="/firmsearch"
            class="btn-sm bg-primary text-white text-bold"
            >Firm Search</router-link
          >
          <router-link
            v-if="user_details.isSystemAdministrator || user_details.isAdministrator"
            to="/usersearch"
            class="btn-sm bg-primary text-white text-bold"
            >User Search</router-link
          >
          <router-link
            v-if="user_details.isSystemAdministrator || user_details.isAdministrator"
            :to="{
              path: 'useradd',
              query: { ID: 0, APPID: 0 }
            }"
            class="btn-sm bg-primary text-white text-bold"
            >Add User</router-link
          >
          <router-link
            v-if="user_details.isSystemAdministrator || user_details.isAdministrator"
            to="/importusers"
            class="btn-sm bg-primary text-white text-bold"
            >Import Users</router-link
          >
          <router-link
            v-if="user_details.isSystemAdministrator || user_details.isAdministrator"
            to="/reports"
            class="btn-sm bg-primary text-white text-bold"
            >Reports</router-link
          >
        </div>
      </div>
      <table class="links-table" >      
        <tr>
          <th style="width: 10%;" v-if="user_details.links.length > 0">Database</th>
          <th style="width: 35%;" v-if="user_details.links.length > 0">Firm</th>
          <th style="width: 20%;" v-if="user_details.links.length > 0">Permissions</th>
          <th style="width: 12%;" v-if="user_details.links.length > 0">Open Documents</th>
          <th @click.prevent="logout">
            <span class="mr-1">Logout</span>
            <img src="../assets/logout.svg" alt />
          </th>
        </tr> 
        <template v-if="user_details.links.length > 0">
        <tr  v-for="(link, i) in user_details.links" :key="i"  >
          <td>{{ link.applicationDescription }}</td>
          <td>{{ link.firmName }}</td>
          <td>
            <div class="LTS-Permissions-Container">
              <div
                v-if="hasPermission(link.permissions, 'A')"
                class="LTS-Permission Permission-A"
                :title="getPermissionDescription('A', link.permissionDetails)"
              >
                {{ getPermissionAbbreviation("A", link.permissionDetails) }}
              </div>
              <div
                v-if="hasPermission(link.permissions, 'B')"
                class="LTS-Permission Permission-B"
                :title="getPermissionDescription('B', link.permissionDetails)"
              >
                {{ getPermissionAbbreviation("B", link.permissionDetails) }}
              </div>
              <div
                v-if="hasPermission(link.permissions, 'C')"
                class="LTS-Permission Permission-C"
                :title="getPermissionDescription('C', link.permissionDetails)"
              >
                {{ getPermissionAbbreviation("C", link.permissionDetails) }}
              </div>
              <div
                v-if="hasPermission(link.permissions, 'D')"
                class="LTS-Permission Permission-D"
                :title="getPermissionDescription('D', link.permissionDetails)"
              >
                {{ getPermissionAbbreviation("D", link.permissionDetails) }}
              </div>
              <div
                v-if="hasPermission(link.permissions, 'E')"
                class="LTS-Permission Permission-E"
                :title="getPermissionDescription('E', link.permissionDetails)"
              >
                {{ getPermissionAbbreviation("E", link.permissionDetails) }}
              </div>
              <div
                v-if="hasPermission(link.permissions, 'F')"
                class="LTS-Permission Permission-F"
                :title="getPermissionDescription('F', link.permissionDetails)"
              >
                {{ getPermissionAbbreviation("F", link.permissionDetails) }}
              </div>
              <div
                v-if="hasPermission(link.permissions, 'G')"
                class="LTS-Permission Permission-G"
                :title="getPermissionDescription('G', link.permissionDetails)"
              >
                {{ getPermissionAbbreviation("G", link.permissionDetails) }}
              </div>
              <div
                v-if="hasPermission(link.permissions, 'H')"
                class="LTS-Permission Permission-H"
                :title="getPermissionDescription('H', link.permissionDetails)"
              >
                {{ getPermissionAbbreviation("H", link.permissionDetails) }}
              </div>
              <div
                v-if="hasPermission(link.permissions, 'I')"
                class="LTS-Permission Permission-I"
                :title="getPermissionDescription('I', link.permissionDetails)"
              >
                {{ getPermissionAbbreviation("I", link.permissionDetails) }}
              </div>
              <div
                v-if="hasPermission(link.permissions, 'J')"
                class="LTS-Permission Permission-J"
                :title="getPermissionDescription('J', link.permissionDetails)"
              >
                {{ getPermissionAbbreviation("J", link.permissionDetails) }}
              </div>
              <div
                v-if="hasPermission(link.permissions, 'K')"
                class="LTS-Permission Permission-K"
                :title="getPermissionDescription('K', link.permissionDetails)"
              >
                {{ getPermissionAbbreviation("K", link.permissionDetails) }}
              </div>
              <div
                v-if="hasPermission(link.permissions, 'M')"
                class="LTS-Permission Permission-M"
                :title="getPermissionDescription('M', link.permissionDetails)"
              >
                {{ getPermissionAbbreviation("M", link.permissionDetails) }}
              </div>
              <div
                v-if="hasPermission(link.permissions, 'R')"
                class="LTS-Permission Permission-R"
                :title="getPermissionDescription('R', link.permissionDetails)"
              >
                {{ getPermissionAbbreviation("R", link.permissionDetails) }}
              </div>
              <div
                v-if="hasPermission(link.permissions, 'T')"
                class="LTS-Permission Permission-T"
                :title="getPermissionDescription('T', link.permissionDetails)"
              >
                {{ getPermissionAbbreviation("T", link.permissionDetails) }}
              </div>
              <div
                v-if="hasPermission(link.permissions, '1')"
                class="LTS-Permission Permission-1"
                :title="getPermissionDescription('1', link.permissionDetails)"
              >
                {{ getPermissionAbbreviation("1", link.permissionDetails) }}
              </div>
              <div
                v-if="hasPermission(link.permissions, '2')"
                class="LTS-Permission Permission-2"
                :title="getPermissionDescription('2', link.permissionDetails)"
              >
                {{ getPermissionAbbreviation("2", link.permissionDetails) }}
              </div>
              <div
                v-if="hasPermission(link.permissions, '3')"
                class="LTS-Permission Permission-3"
                :title="getPermissionDescription('3', link.permissionDetails)"
              >
                {{ getPermissionAbbreviation("3", link.permissionDetails) }}
              </div>
              <div
                v-if="hasPermission(link.permissions, 'Z')"
                class="LTS-Permission Permission-Z"
                :title="getPermissionDescription('Z', link.permissionDetails)"
              >
                {{ getPermissionAbbreviation("Z", link.permissionDetails) }}
              </div>
            </div>
          </td>
          <td>
            <div class="tooltip">
              {{ getOpenDocumentCount(link) }}
              <span class="tooltiptext" v-if="getOpenDocumentCount(link) > 0">
                <div v-if="link.openSRDocuments.length > 0">
                  <div>
                    Open
                    {{ getShortDocumentDescription(0, link.documentDetails) }}'s
                  </div>
                  <table>
                    <tr>
                      <th style="width: 6%;">Id</th>
                      <th style="width: 15%;">Learner</th>
                      <th style="width: 15%;">
                        {{ getPermissionDescription("B", link.permissionDetails) }}
                      </th>
                      <th style="width: 15%;">Start</th>
                      <th style="width: 10%;">Days Open</th>
                      <th style="width: 24%;">Client Description</th>
                      <th>Status</th>
                    </tr>
                    <tr v-for="(openSRDoc, i) in link.openSRDocuments" :key="i">
                      <td>{{ openSRDoc.documentId }}</td>
                      <td>{{ openSRDoc.learner }}</td>
                      <td>{{ openSRDoc.reviewer }}</td>
                      <td>{{ openSRDoc.start }}</td>
                      <td>{{ openSRDoc.daysOpen }}</td>
                      <td>{{ openSRDoc.clientDescription }}</td>
                      <td>{{ openSRDoc.status }}</td>
                    </tr>
                  </table>
                </div>
                <br v-if="link.openSRDocuments.length > 0 && link.openANADocuments.length > 0" />
                <div v-if="link.openANADocuments.length > 0">
                  <div>
                    Open
                    {{ getShortDocumentDescription(1, link.documentDetails) }}'s
                  </div>
                  <table>
                    <tr>
                      <th style="width: 6%;">Id</th>
                      <th style="width: 15%;">Learner</th>
                      <th style="width: 15%;">
                        {{ getPermissionDescription("D", link.permissionDetails) }}
                      </th>
                      <th style="width: 15%;">
                        {{ getPermissionDescription("F", link.permissionDetails) }}
                      </th>
                      <th style="width: 15%;">Start</th>
                      <th style="width: 10%;">Days Open</th>
                      <th>Status</th>
                    </tr>
                    <tr v-for="(openANADoc, i) in link.openANADocuments" :key="i">
                      <td>{{ openANADoc.documentId }}</td>
                      <td>{{ openANADoc.learner }}</td>
                      <td>{{ openANADoc.evaluator }}</td>
                      <td>{{ openANADoc.assessor }}</td>
                      <td>{{ openANADoc.start }}</td>
                      <td>{{ openANADoc.daysOpen }}</td>
                      <td>{{ openANADoc.status }}</td>
                    </tr>
                  </table>
                </div>
                <br
                  v-if="
                    (link.openSRDocuments.length > 0 || link.openANADocuments.length > 0) &&
                      link.openTSDocuments.length > 0
                  "
                />
                <div v-if="link.openTSDocuments.length > 0">
                  <div>
                    Open
                    {{ getShortDocumentDescription(2, link.documentDetails) }}'s
                  </div>
                  <table>
                    <tr>
                      <th style="width: 6%;">Id</th>
                      <th style="width: 20%;">Learner</th>
                      <th style="width: 20%;">
                        {{ getPermissionDescription("B", link.permissionDetails) }}
                      </th>
                      <th style="width: 20%;">Start</th>
                      <th style="width: 10%;">Days Open</th>
                      <th>Status</th>
                    </tr>
                    <tr v-for="(openTSDoc, i) in link.openTSDocuments" :key="i">
                      <td>{{ openTSDoc.documentId }}</td>
                      <td>{{ openTSDoc.learner }}</td>
                      <td>{{ openTSDoc.reviewer }}</td>
                      <td>{{ openTSDoc.start }}</td>
                      <td>{{ openTSDoc.daysOpen }}</td>
                      <td>{{ openTSDoc.status }}</td>
                    </tr>
                  </table>
                </div>
                <br
                  v-if="
                    (link.openSRDocuments.length > 0 ||
                      link.openANADocuments.length > 0 ||
                      link.openTSDocuments.length > 0) &&
                      link.openIRBAMonthlyDocuments.length > 0
                  "
                />
                <div v-if="link.openIRBAMonthlyDocuments.length > 0">
                  <div>
                    Open
                    {{ getShortDocumentDescription(3, link.documentDetails) }}'s
                  </div>
                  <table>
                    <tr>
                      <th style="width: 6%;">Id</th>
                      <th style="width: 15%;">
                        {{ getPermissionDescription("1", link.permissionDetails) }}
                      </th>
                      <th style="width: 15%;">
                        {{ getPermissionDescription("2", link.permissionDetails) }}
                      </th>
                      <th style="width: 15%;">
                        {{ getPermissionDescription("3", link.permissionDetails) }}
                      </th>
                      <th style="width: 20%;">Start</th>
                      <th style="width: 10%;">Days Open</th>
                      <th>Status</th>
                    </tr>
                    <tr v-for="(openIRBAMonthlyDoc, i) in link.openIRBAMonthlyDocuments" :key="i">
                      <td>{{ openIRBAMonthlyDoc.documentId }}</td>
                      <td>{{ openIRBAMonthlyDoc.rca }}</td>
                      <td>{{ openIRBAMonthlyDoc.dlm }}</td>
                      <td>{{ openIRBAMonthlyDoc.ora }}</td>
                      <td>{{ openIRBAMonthlyDoc.start }}</td>
                      <td>{{ openIRBAMonthlyDoc.daysOpen }}</td>
                      <td>{{ openIRBAMonthlyDoc.status }}</td>
                    </tr>
                  </table>
                </div>
                <br
                  v-if="
                    (link.openSRDocuments.length > 0 ||
                      link.openANADocuments.length > 0 ||
                      link.openTSDocuments.length > 0 ||
                      link.openIRBAMonthlyDocuments.length > 0) &&
                      link.openIRBASixMonthlyDocuments.length > 0
                  "
                />
                <div v-if="link.openIRBASixMonthlyDocuments.length > 0">
                  <div>
                    Open
                    {{ getShortDocumentDescription(4, link.documentDetails) }}'s
                  </div>
                  <table>
                    <tr>
                      <th style="width: 6%;">Id</th>
                      <th style="width: 15%;">
                        {{ getPermissionDescription("1", link.permissionDetails) }}
                      </th>
                      <th style="width: 15%;">
                        {{ getPermissionDescription("2", link.permissionDetails) }}
                      </th>
                      <th style="width: 15%;">
                        {{ getPermissionDescription("3", link.permissionDetails) }}
                      </th>
                      <th style="width: 20%;">Start</th>
                      <th style="width: 10%;">Days Open</th>
                      <th>Status</th>
                    </tr>
                    <tr v-for="(openIRBASixMonthlyDoc, i) in link.openIRBASixMonthlyDocuments" :key="i">
                      <td>{{ openIRBASixMonthlyDoc.documentId }}</td>
                      <td>{{ openIRBASixMonthlyDoc.rca }}</td>
                      <td>{{ openIRBASixMonthlyDoc.dlm }}</td>
                      <td>{{ openIRBASixMonthlyDoc.ora }}</td>
                      <td>{{ openIRBASixMonthlyDoc.start }}</td>
                      <td>{{ openIRBASixMonthlyDoc.daysOpen }}</td>
                      <td>{{ openIRBASixMonthlyDoc.status }}</td>
                    </tr>
                  </table>
                </div>
                <br
                  v-if="
                    (link.openSRDocuments.length > 0 ||
                      link.openANADocuments.length > 0 ||
                      link.openTSDocuments.length > 0 ||
                      link.openIRBAMonthlyDocuments.length > 0 ||
                      link.openIRBASixMonthlyDocuments.length > 0) &&
                      link.openBDOTPADocuments.length > 0
                  "
                />
                <div v-if="link.openBDOTPADocuments.length > 0">
                  <div>
                    Open
                    {{ getLongDocumentDescription(18, link.documentDetails) }}'s
                  </div>
                  <table>
                    <tr>
                      <th style="width: 15%;">
                        {{ getPermissionDescription("E", link.permissionDetails) }}
                      </th>
                      <th style="width: 15%;">
                        {{ getPermissionDescription("C", link.permissionDetails) }}
                      </th>
                      <th style="width: 15%;">
                        {{ getPermissionDescription("R", link.permissionDetails) }}
                      </th>
                      <th style="width: 10%;">Start</th>
                      <th style="width: 5%;">Days Open</th>
                      <th style="width: 15%;">Client Name</th>
                      <th>Current Step</th>
                      <th>Assigned To</th>
                    </tr>
                    <tr v-for="(openBDOTPADoc, i) in link.openBDOTPADocuments" :key="i">
                      <td>{{ openBDOTPADoc.employee }}</td>
                      <td>{{ openBDOTPADoc.contributor }}</td>
                      <td>{{ openBDOTPADoc.reviewer }}</td>
                      <td>{{ openBDOTPADoc.start.replace(" 00:00:00", "") }}</td>
                      <td>{{ openBDOTPADoc.daysOpen }}</td>
                      <td>{{ openBDOTPADoc.clientName }}</td>
                      <td>{{ openBDOTPADoc.currentStep }}</td>
                      <td>{{ openBDOTPADoc.assignedTo }}</td>
                    </tr>
                  </table>
                </div>
                <br
                  v-if="
                    (link.openSRDocuments.length > 0 ||
                      link.openANADocuments.length > 0 ||
                      link.openTSDocuments.length > 0 ||
                      link.openIRBAMonthlyDocuments.length > 0 ||
                      link.openIRBASixMonthlyDocuments.length > 0 ||
                      link.openBDOTPADocuments.length > 0) &&
                      link.openMSMRDocuments.length > 0
                  "
                />
                <div v-if="link.openMSMRDocuments.length > 0">
                  <div>
                    Open
                    {{ getLongDocumentDescription(20, link.documentDetails) }}'s
                  </div>
                  <table>
                    <tr>
                      <th style="width: 15%;">
                        {{ getPermissionDescription("E", link.permissionDetails) }}
                      </th>
                      <th style="width: 15%;">
                        {{ getPermissionDescription("R", link.permissionDetails) }}
                      </th>
                      <th style="width: 10%;">Start</th>
                      <th style="width: 5%;">Days Open</th>
                      <th>Current Step</th>
                      <th>Assigned To</th>
                    </tr>
                    <tr v-for="(openMSMRDoc, i) in link.openMSMRDocuments" :key="i">
                      <td>{{ openMSMRDoc.employee }}</td>
                      <td>{{ openMSMRDoc.reviewer }}</td>
                      <td>{{ openMSMRDoc.start.replace(" 00:00:00", "") }}</td>
                      <td>{{ openMSMRDoc.daysOpen }}</td>
                      <td>{{ openMSMRDoc.currentStep }}</td>
                      <td>{{ openMSMRDoc.assignedTo }}</td>
                    </tr>
                  </table>                
                </div>
              </span>
            </div>
          </td>
          <td>
            <router-link
              target="_blank"
              :to="{
                path: 'linkredirect',
                query: {
                  applicationId: link.applicationID,
                  applicationUserId: link.userProfileId
                }
              }"
            >
              <img
                class="link-button"
                :src="require(`../images/${link.applicationImage.replace('images/', '')}`)"
                alt="LOGIN"
              />
            </router-link>
          </td>
        </tr>
        </template>
        <template v-else>
          <tr>
            <td colspan="5" style="display:revert;text-align:center;color:red;">
                <strong>NO ACTIVE PROFILE </strong>linked to this account!<br>Please LOGOUT and logon to LTSystems.co.za with your active account, or/ use the below FORGOT PASSWORD function to retrieve your active account information, or/ contact <a class="ahof" href="mailto:support@ltsystems.co.za"><strong style="text-decoration:underline;">Support@LTSystems.co.za</strong></a> if you require further assistance.
              </td>
          </tr>
          <tr>
            <td colspan="5" style="display:revert;text-align:center;color:red;">
                &nbsp;
              </td>
          </tr>
          <tr>
            <td colspan="5" style="display:revert;text-align:center;">
              <div class="forgotpassword container">
    <div class="forgotpassword-card">
      <div class="forgotpassword-card-header">LTS Forgotten Password</div>
      <div v-if="!credentialsSent" class="forgotpassword-card-body">
        <form @submit.prevent="sendLoginCredentials">
          <div v-show="error" class="error">{{ error }}</div>
          <div class="mb-2 heading-message">
            Please enter either your <span class="text-bold">Username</span> or <span class="text-bold">Email Address</span> in the textbox below and then click on the <span class="text-bold">Send Login Credentials</span> button.
          </div>
          <div class="mb-3">
            <label for="username">Username / Email Address</label>
            <input id="username" v-model="username" class="textbox mt-1" type="text" />
            <small v-show="username_invalid" class="required">Please enter a username</small>
          </div>
          <input v-show="!isSearchingCredentials" type="submit" value="Send Login Credentials" class="btn-sm bg-primary text-white text-bold" />
          <Loader v-show="isSearchingCredentials" class="loader"></Loader>
        </form>
      </div>
      <div v-if="credentialsSent && resp.status == 1" class="forgotpassword-card-body">
        <form @submit.prevent="reloadPage">
          <div class="mb-2 heading-message">
            Your login credentials has been sent. If you did not receive your login credentials, please contact LTS Support at <span class="text-bold">support@ltsystems.co.za</span>.
          </div>
          <input type="submit" value="Ok" class="btn-sm bg-primary text-white text-bold" />
        </form>
      </div>
      <div v-else-if="credentialsSent && resp.status == 0" class="forgotpassword-card-body">
        <form @submit.prevent="reloadPage">
          <div class="mb-2 heading-message">
            {{resp.message}}. Please contact LTS Support at <span class="text-bold">support@ltsystems.co.za</span>.
          </div>
          <input type="submit" value="Ok" class="btn-sm bg-primary text-white text-bold" />
        </form>
      </div>
    </div>
  </div>
          </td>
        </tr>
        </template>
      </table>
      <Loader v-if="loading" class="loader"></Loader>
    </div>
  </div>
</template>

<script>
import LTSHeader from "@/components/LTSHeader";
import Loader from "@/components/Loader.vue";
import axios from "axios";



export default {
  components: {
    LTSHeader,
    Loader
  },
  data: () => {
    return {
      loading: true,
      user_details: {},
      resp:{},
      isSearchingCredentials: false,
      username: "",
      username_invalid: false,
      error: "",
      credentialsSent: false
    };
  },
  mounted() {
    // Fetch links for logged in user
    axios
      .get("/links")
      .then((response) => {
        if (response.data.links.length == 1) {
          this.$router.push({
            path: "linkredirect",
            query: {
              applicationId: response.data.links[0].applicationID,
              applicationUserId: response.data.links[0].userProfileId
            }
          });
        } else {
          this.user_details = response.data;
        }
      })
      .catch((err) => {
        console.log(err.response);
      });
  },
  updated: function() {
    this.$nextTick(function() {
      // Code that will run only after the
      // entire view has been re-rendered
      this.loading = false;
    });
  },
  methods: {
    logout: function() {
      // Remove the local Jwt
      localStorage.removeItem("token");

      // Go back to the login page
      // this.$router.push("/");
      window.location.replace("http://www.ltsystems.co.za");
    },
    getOpenDocumentCount: function(userProfile) {
      return (
        userProfile.openSRDocuments.length +
        userProfile.openANADocuments.length +
        userProfile.openTSDocuments.length +
        userProfile.openIRBAMonthlyDocuments.length +
        userProfile.openIRBASixMonthlyDocuments.length +
        userProfile.openBDOTPADocuments.length
      );
    },
    getPermissionDescription: function(permission, permissionDetails) {
      var description = "";

      permissionDetails.forEach((pd) => {
        if (pd.permission === permission) {
          description = pd.description;
        }
      });

      return description;
    },
    getPermissionAbbreviation: function(permission, permissionDetails) {
      var description = "";
      var abbreviation = "";

      permissionDetails.forEach((pd) => {
        if (pd.permission === permission) {
          description = pd.description;
        }
      });

      // Build the abbreviation
      abbreviation = description
        .split(/\b(?=[a-z])/gi) // split on word boundaries
        .map((token) => token[0]) // get first letter of each token
        .join("")
        .toUpperCase(); // convert to lowercase string

      return abbreviation;
    },
    getShortDocumentDescription: function(type, documentDetails) {
      var description = "";

      documentDetails.forEach((dd) => {
        if (dd.type === type) {
          description = dd.shortDescription;
        }
      });

      return description;
    },
    getLongDocumentDescription: function(type, documentDetails) {
      var description = "";

      documentDetails.forEach((dd) => {
        if (dd.type === type) {
          description = dd.longDescription;
        }
      });

      return description;
    },
    hasPermission: function(permissions, permission) {
      return permissions.toUpperCase().indexOf(permission) !== -1;
    },
     sendLoginCredentials: function() {
      this.isSearchingCredentials = true;
      this.error = "";

      // Validation
      this.username.trim().length > 0
        ? (this.username_invalid = false)
        : (this.username_invalid = true);

      if (this.username_invalid) {
        this.isSearchingCredentials = false;
        return;
      }

      // Call the login api
      axios
        .post("/users/forgotPasswordwithresponse", { username: this.username })
        .then(response => {
          this.credentialsSent = true;
          this.resp = response.data;
        })
        .catch(() => {
            this.error = "Internal error occured. Please contact LTS support.";
        })
        .finally(() => {
            this.isSearchingCredentials = false;
        });
    },
    reloadPage: function() {
      location.reload();
    }
  }
};
</script>

<style lang="scss" scoped>
/* IMPORT VARIABLES */
@import "@/styles/_variables.scss";

.user-details {
  background: #f8f8ff;
  display: flex;
  justify-content: space-between;
  padding: 0.3rem;
  border: 1px solid $grey-color;

  .admin-description {
    font-weight: bold;
  }

  .admin-buttons {
    display: flex;

    a {
      margin: 2px;
      display: block;
      text-decoration: none;
    }
  }
}

.loader {
  height: 5rem;
  margin: 0 auto;
}

.links-table {
  width: 100%;
  background: #f8f8ff;
  border: 1px solid $grey-color;
  border-collapse: collapse;
  font-size: 0.8rem;

  tr:nth-child(odd) {
    background: #ededff;
  }

  th {
    text-align: left;
    padding: 0.8rem;
    font-weight: bold;
    background: $dark-blue-color;
    color: $white-color;
  }

  th:last-child {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    text-align: right;
    cursor: pointer;
  }

  td {
    padding: 0.2rem 0.8rem;
  }

  td:last-child {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
}

.link-button {
  cursor: pointer;
}

// Tooltip stuff -----------------------------------------------------------------
.tooltip {
  position: relative;
  display: inline-block;
  border-bottom: 1px dotted black;

  table {
    width: 100%;
    background: #f8f8ff;
    border: 1px solid $grey-color;
    border-collapse: collapse;
    font-size: 0.7rem;

    th {
      text-align: left;
      padding: 0.2rem 0.6rem;
      font-weight: bold;
      background: $dark-blue-color;
      color: $white-color;
    }

    th:last-child {
      display: table-cell !important;
      text-align: left !important;
      cursor: text !important;
    }

    td {
      padding: 0.2rem 0.6rem !important;
    }

    td:last-child {
      display: table-cell !important;
      align-items: left !important;
    }
  }
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 800px;
  background-color: #dfdfeb;
  border: 1px solid $grey-color;
  color: black;
  text-align: left;
  border-radius: 6px;
  padding: 5px;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  top: 100%;
  left: 50%;
  margin-left: -450px;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}

.ahof{
  color:red;
}

.ahof:hover{
  color:darkred;
}
</style>
